import React from 'react'
import Header from '../../Components/Header'
import PrototypeFabrication from '../../Components/prototypeFabricationCapabilities'
import DevProduct from "../../imagens/devProduto/devProduto.png"
import DevProduct2 from "../../imagens/devProduto/devProduto2.png"
import DevProduct3 from "../../imagens/devProduto/devProduto3.png"
import DevProduct4 from "../../imagens/devProduto/devProduto4.png"
import DevProduct5 from "../../imagens/devProduto/devProduto5.png"
import DevProduct6 from "../../imagens/devProduto/devProduto6.png"
import DevProduct7 from "../../imagens/devProduto/devProduto7.png"


const listPrototypeFabrication = [
    {
        img: DevProduct
    },
    {
        img: DevProduct2
    },
    {
        img: DevProduct3
    },
    {
        img: DevProduct4
    },
    {
        img: DevProduct5
    },
    {
        img: DevProduct6
    },
    {
        img: DevProduct7
    },
]


const PrototypeFabricationPage = () => {
    return (
        <div>
            <Header />
            <PrototypeFabrication
                listPrototypeFabrication={listPrototypeFabrication}
            />
        </div>
    )
}

export default PrototypeFabricationPage